import classNames from "classnames";
import { FileUploader } from "lucy/common-components";
import * as React from "react";
import { Button, Checkbox, Input, Label, MultiSelect, Select } from "uxp/components";
import { hasValue } from "../../../../util";
import { IBaseFieldProperty, IBaseInputFieldProperty, IPropertyEditorProps, IUIFieldProps, registerUIField } from "../../common";
import ActionButton from "../../components/ActionButton";
import { FieldProperty, FieldTitle, IFieldTitleProps } from "../../components/FieldTitle";
import IconEditor, { generateIconPropAsSting } from "../../icon-selector/IconEditor";
import { CustomColorPicker, escapeUnit, Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle, TextAlignEditor } from "../../ui-props/common";

interface IUploadFieldProperty extends IBaseInputFieldProperty {
	text: string, // button label
	title: string, // field label
	allowOnlyOnePhoto: boolean,
	allowedTypes: string[]
	buttonIcon: string,
	fieldLabel: IFieldTitleProps
}

export const Field: React.FunctionComponent<IUIFieldProps<IUploadFieldProperty>> = (props) => {

	let { text, title, onChange, value, fieldLabel } = props.fieldProps || {}
	let styles: React.CSSProperties = {}

	const [fileName, setFileName] = React.useState<string>('')
	return (
		<div className={classNames('ui-field', props.mode)} >

			{hasValue(title) && <div className='ui-field-label'>{(fieldLabel.required ? '*' : '') + title}</div>}
			{hasValue(fieldLabel.description) && <div className='ui-field-description'>{fieldLabel.description}</div>}

			<FileUploader
				pathToUpload='canvas/uploads/'
				uxpContext={props.uxpContext}
				title={"Upload"}
				actionButtonText={"Upload this file"}
				afterUpload={(url, filename) => {
					setTimeout(() => {
						setFileName(filename)
						onChange(url)

						console.log(`File uploaded -> Url: ${url}, File name: ${filename} `)
					}, 500)
				}}
				allowedTypes={props?.fieldProps?.allowedTypes || []}
			>
				<Button
					title={!fileName ? (text || 'Upload File') : 'Change File'}
					icon={generateIconPropAsSting(props?.fieldProps?.buttonIcon || 'upload')}
					onClick={() => { }}
				/>
				{value && <Label>{fileName}</Label>}
			</FileUploader>
		</div >
	)
}


export const PropertyEditor: React.FunctionComponent<IPropertyEditorProps<IUploadFieldProperty>> = (props) => {
	return <PropertyContainer>
		<PropertyGroup>
			<PropertyGroupTitle>Upload File</PropertyGroupTitle>


			<Property>
				<PropertyTitle>Allowed file types</PropertyTitle>
				<small>Keep empty for allowing any file type</small>
				<MultiSelect
					selected={props.uiProps.allowedTypes || []}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { allowedTypes: s }))}
					className="widget-designer-input"
					options={[
						{
							label: 'All images',
							value: 'image/*'
						},
						{
							label: 'All videos',
							value: 'video/*'
						},
						{
							label: 'All audio',
							value: 'audio/*'
						},
						{
							label: 'JPEG images',
							value: 'image/jpeg'
						},
						{
							label: 'JPG images',
							value: 'image/jpg'
						},
						{
							label: 'PNG images',
							value: 'image/png'
						},
						{
							label: 'SVG images',
							value: 'image/svg'
						},
						{
							label: 'GIF images',
							value: 'image/GIP'
						},
						{
							label: 'Bitmap images',
							value: 'image/bmp'
						},
						{
							label: 'MP4 videos',
							value: 'video/mp4'
						},
						{
							label: 'MP3 audio',
							value: 'audio/mp3'
						},
						{
							label: 'PDF',
							value: 'application/pdf'
						},
						{
							label: 'CSV',
							value: 'text/csv'
						},
						{
							label: 'Excel (.xls)',
							value: 'application/vnd.ms-excel'
						},
						{
							label: 'Excel (.xlsx)',
							value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
						},
						{
							label: 'Word (.doc)',
							value: 'application/msword'
						},
						{
							label: 'Word (.docx)',
							value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
						},
						{
							label: 'JSON',
							value: 'application/json'
						},
					]}
				/>
			</Property>
			<Property>
				<PropertyTitle>Button Label</PropertyTitle>
				<Input
					value={props.uiProps.text || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { text: s }))}
					className="widget-designer-input"
				/>
			</Property>

			<Property>
				<PropertyTitle>Button Icon</PropertyTitle>
				<IconEditor
					value={props.uiProps.buttonIcon || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { buttonIcon: s }))}
				/>
			</Property>

			<Property>
				<Checkbox
					checked={props.uiProps.allowOnlyOnePhoto || false}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { allowOnlyOnePhoto: s }))}
					label="Allow only one file"
				/>
			</Property>


		</PropertyGroup>

		<PropertyGroup>
			<PropertyGroupTitle>Label</PropertyGroupTitle>
			<Property>
				<PropertyTitle>Label</PropertyTitle>
				<Input
					value={props.uiProps.title || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { title: s }))}
					className="widget-designer-input"
				/>
			</Property>
			<Property>
				<PropertyTitle>Description</PropertyTitle>
				<Input
					value={props.uiProps.fieldLabel.description || ''}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { fieldLabel: { ...props.uiProps.fieldLabel, description: s } }))}
					className="widget-designer-input"
				/>
			</Property>
			<Property>
				<PropertyTitle>Required Field</PropertyTitle>
				<Checkbox
					checked={!!props.uiProps.fieldLabel.required}
					label={'It is mandatory to fill this field'}
					onChange={s => props.onChange(Object.assign({}, props.uiProps, { fieldLabel: { ...props.uiProps.fieldLabel, required: s } }))}
					className="widget-designer-input"
				/>
			</Property>
		</PropertyGroup>

	</PropertyContainer>;
}
registerUIField({
	id: 'upload',
	description: 'Upload File',
	field: Field,
	isInputField: true,
	type: 'file',
	propertyEditor: PropertyEditor,
	defaultProps: {
		title: 'Upload file',
		text: 'Upload file',
		allowedTypes: [],
		buttonIcon: 'upload',
		allowOnlyOnePhoto: false,
		fieldLabel: {
			label: 'Upload file',
		},
	}
});


